import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { COACH_MARKS } from '../../constants/onboardingContent';
import { dismissCoachMark, shouldShowCoachMark } from '../../utils/onboardingStorage';

const Banner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  padding: 1rem 1.1rem;
  margin-bottom: 1.25rem;
  border-radius: 0.85rem;
  background: linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%);
  border: 1px solid #a7f3d0;
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.08);
`;

const Content = styled.div`
  flex: 1;
  min-width: 0;
`;

const Title = styled.p`
  margin: 0 0 0.25rem;
  font-weight: 700;
  color: #065f46;
  font-size: 0.92rem;
`;

const Body = styled.p`
  margin: 0;
  color: #047857;
  font-size: 0.84rem;
  line-height: 1.5;
`;

const CloseBtn = styled.button`
  border: none;
  background: transparent;
  color: #059669;
  font-size: 1.25rem;
  line-height: 1;
  cursor: pointer;
  padding: 0.15rem;
  flex-shrink: 0;
`;

export default function ContextualCoachBanner({ coachId }) {
  const [visible, setVisible] = useState(false);
  const copy = COACH_MARKS[coachId];

  useEffect(() => {
    if (coachId && copy) {
      setVisible(shouldShowCoachMark(coachId));
    }
  }, [coachId, copy]);

  if (!visible || !copy) return null;

  const handleDismiss = () => {
    dismissCoachMark(coachId);
    setVisible(false);
  };

  return (
    <Banner role="note">
      <Content>
        <Title>{copy.title}</Title>
        <Body>{copy.body}</Body>
      </Content>
      <CloseBtn type="button" onClick={handleDismiss} aria-label="Dismiss tip">
        ×
      </CloseBtn>
    </Banner>
  );
}
